//
// **CAUTION: add zod validator if will be used on production**
//

const localStorageFactory = <R>(cellName: string) => {
  const set = (obj: R) => {
    if (typeof window === "undefined") return;
    if (process.env.SITE_ENV !== "local" && process.env.SITE_ENV !== "tgb") {
      return;
    }

    localStorage.setItem(cellName, JSON.stringify(obj));
  };

  const get = (): R | null => {
    if (typeof window === "undefined") return null;
    if (process.env.SITE_ENV !== "local" && process.env.SITE_ENV !== "tgb") {
      return null;
    }

    const item = localStorage.getItem(cellName);
    if (!item) return null;
    return JSON.parse(item);
  };

  return {
    set,
    get,
  };
};

export const TEMPORARY_isNextAuthLocalStorage = localStorageFactory<boolean>(
  "isNextAuthLocalStorage",
);
